import { Header, Subheader, HeaderContainer, PrimaryButton } from "./SharedStyles";
import TermsPrivacy from "./TermsPrivacy";
import CircleCheck from "@/components/UI/Icons/CircleCheck";
import I18n from "../../../translations/i18n";

type PasswordProps = {
  onLoginClick: () => void;
}

const ResetPasswordConfirmationScreen = ({ onLoginClick }: PasswordProps) => {
  return (
    <>
      <HeaderContainer>
        <Header>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.reset_password.header`)}</Header>
        <Subheader>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.reset_password.subheader`)}</Subheader>
      </HeaderContainer>
      <div style={{margin: "8px 0"}}>
        <CircleCheck />
      </div>
      
      <PrimaryButton onClick={onLoginClick}>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.buttons.sign_in`)}</PrimaryButton>
      <TermsPrivacy/>
    </>
  );
}

export default ResetPasswordConfirmationScreen;